module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-circle-0b7767cc.svg";